import appColors from 'utils/appColors';
import { makeStyles } from '@material-ui/core';
import styled from 'styled-components';

export const useStyles = makeStyles(() => ({
  root: {
    minHeight: '100vh',
    backgroundColor: appColors.BACKGROUND_COLOR,
  },
  headerCard: {
    backgroundColor: '#FFFFFF',
    border: '1px solid #E6E8EB',
    borderRadius: 16,
    padding: '12px 16px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
    marginBottom: 8,
  },
  unitsAndFiltersRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: 12,
    width: '100%',
  },
  tabsWrapper: {
    flex: '1 1 0',
    minWidth: 0,
    overflow: 'hidden',
    '& .MuiTabs-root': {
      minHeight: 44,
    },
  },
  rowContainer: {
    marginTop: 8,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: 16,
    width: '100%',
  },
  buttonHover: {
    '&:hover': {
      backgroundColor: appColors.PRIMARY_COLOR,
    },
  },
  filtro: {},
}));

export const DefaultContainer = styled.div`
  padding-top: 4%;
  text-align: flex-start;
  margin-left: 14%;
  @media (max-width: 1920px) {
    padding-top: 4%;
    margin-left: 14%;
  }
  @media (max-width: 1440px) {
    padding-top: 5%;
    margin-left: 18%;
  }
  @media (max-width: 1366px) {
    padding-top: 5%;
    margin-left: 18%;
  }
  @media (max-width: 1024px) {
    padding-top: 7%;
    margin-left: 25%;
  }
  @media (max-width: 768px) {
    padding-top: 7%;
    margin-left: 33%;
  }
`;
